import { Main } from '@/modules/profile/components/Main/Main'
import { SupportForm } from '@/modules/support/components/SupportForm/SupportForm'

export function Component() {
  return (
    <Main header="Support">
      <SupportForm />
    </Main>
  )
}

Component.displayName = 'Support'
